import {Link} from '@tanstack/react-router';

/** Rendered when a user navigates to a route they don't have a role for. */
function ForbiddenPage({message}: {message?: string}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm rounded-xl bg-white p-8 shadow-sm ring-1 ring-slate-200">
        <h1 className="mb-2 text-xl font-semibold text-slate-900">
          Access denied
        </h1>
        <p className="mb-6 text-sm text-slate-500">
          {message ?? "You don't have permission to access this page."}
        </p>
        <Link
          to="/"
          className="text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          ← Back to home
        </Link>
      </div>
    </div>
  );
}

export default ForbiddenPage;
